var _defs, _rect, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCreateCitation(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 800 800",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .st0 {\n        fill: none;\n      }\n\n      .st1 {\n        fill: #d47500;\n      }\n\n      .st2 {\n        fill: #336;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "st0",
    width: 800,
    height: 800
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st2",
    d: "M700,466.7v166.7c0,36.8-29.8,66.7-66.7,66.7H166.7c-36.8,0-66.7-29.8-66.7-66.7V166.7c0-36.8,29.8-66.7,66.7-66.7h166.7v66.7h-166.7v466.7h466.7v-166.7h66.7Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "st1",
    d: "M700,233.3h-133.3V100h-66.7v133.3h-133.3v66.7h133.3v133.3h66.7v-133.3h133.3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCreateCitation);
export default __webpack_public_path__ + "static/media/create_citation.2102f68847f9d1ba16e12c6abe0323d1.svg";
export { ForwardRef as ReactComponent };